export default __webpack_public_path__ + "static/media/unbound_logo.b6670f39.png";